import React, { Component } from 'react';
import './style.css'
import { BoxInputComment } from '../boxComment/boxInputComment'
import { BoxActionComment } from '../boxComment/boxActionComment'
import { SubComment } from './subComment'
import by_me_1 from '../../static/img/dauChamHoi.png'
import by_me_2 from '../../static/img/double-arrow.png'
import callApi from '../../util/callApi';
import Viewer from 'react-viewer'
import moment from 'moment';
import _  from 'lodash'
import { LIMIT_COMMENT_ITEM } from '../../config/config'
import mathJaxUtil from '../../util/mathjaxUtil'

class Comment extends Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            page: 1,
            listComment: [],
            show_answer_id: '',
            totalComment: 0,
            current_image_view: '',
            list_cmt_10_upvote: [],
            by_me: 0
        }
    }

    componentDidUpdate () {
        mathJaxUtil.renderMathjax(document.getElementById('comment'));
        mathJaxUtil.renderMathjax(document.getElementById('preview-mathjax'));
    }

    componentDidMount() {
        mathJaxUtil.renderMathjax(document.getElementByID('comment'))
        mathJaxUtil.renderMathjax(document.getElementById('preview-mathjax'));
    }

    pingMathjax = () =>{
        mathJaxUtil.renderMathjax(document.getElementById('comment'));
        mathJaxUtil.renderMathjax(document.getElementById('preview-mathjax'));
    }

    getDataInApi = async (page) => {
        const { item_id, item_type, user_id} = this.props.props;
        const { listComment, by_me} = this.state;
        var data = {
            item_id: item_id,
            item_type: item_type,
            current_page: page
        }
        if(by_me == 1){
            data.by_me = 1;
        }
        const cmt_over_10_vote = await callApi('v1/user_comment/listCmtOverUpvote', 'get', data);
        if (cmt_over_10_vote && cmt_over_10_vote.status == 1) {
            if(cmt_over_10_vote.data.length > 0){
                const tmp_exclude = _.map(cmt_over_10_vote.data,'_id');
                data.exclude_id = tmp_exclude;
            }
            await this.setState({ list_cmt_10_upvote: cmt_over_10_vote.data})
        }

        const dataFilter = await callApi('v1/user_comment/listCmt', 'get', data);
        if (dataFilter && dataFilter.status == 1) {
            await this.setState({ listComment: [...listComment , ...dataFilter.data.listComment], totalComment: dataFilter.data.count_comment, permission_cmt: dataFilter.data.permission_cmt})
        }
    }


    loadmoreComment = async (page) => {
        this.setState({page: page})
        await this.getDataInApi(page);
    }

    async componentDidMount() {
        const { page } = this.state;
        await this.getDataInApi(page)
    }

    pushCmt = (new_comment) =>{
        const {listComment} = this.state;
        this.setState({
            listComment: [...[new_comment], ...listComment]
        })
    }

    setActionId = (type, action_id) =>{
        if(type="replied")
            this.setState({
                show_answer_id:action_id
            })
    }

    handleViewerImage = (src) => {
        this.setState({visible: true, current_image_view: src})
    }
    hiddenViewer = (e) =>{
        if(e){
            this.setState({
                visible: false
            })
        }
    }

    filterListCommentByme = async () => {
        await this.setState({listComment: [],by_me: 1})
        await this.getDataInApi(1);
    }
    showAll = async () => {
        await this.setState({listComment: [],by_me: 0})
        await this.getDataInApi(1);
    }

    render() {
        const { listComment, totalComment, page, show_answer_id, current_image_view, list_cmt_10_upvote, permission_cmt} = this.state;
        const { item_type, item_id, avatar, user_id, username, is_mod_hoidap, item_action,is_bought_course,is_bought_topic,is_bought_lesson} = this.props.props
        const self = this;
        let check_perm = permission_cmt;
        if(is_bought_course != null){
            if(is_bought_course || is_bought_topic || is_bought_lesson || is_mod_hoidap){
                check_perm = true;
            }else{
                check_perm = false;
            }
        }
        return (
            <div id="comment" className="box282">
                <Viewer
                    width={100}
                    height={100}
                    defaultScale={1.25}
                    onMaskClick={this.hiddenViewer}
                    visible={this.state.visible}
                    scalable={false} zoomSpeed={0.25} activeIndex={0} noNavbar={true} noImgDetails={true} changeable={true} noResetZoomAfterChange={true}
                    onClose={() => { this.setState({ visible: false }); } }
                    visible={this.state.visible}
                    onClose={() => { this.setState({ visible: false }) }}
                    images={[{ src: current_image_view, alt: '' }]}
                />

                { user_id && check_perm ? <>
                    <h3 className="xheader-comment">
                        <a className="totalComment" onClick={this.showAll}>Hỏi đáp và thảo luận</a>
                        <a onClick={this.filterListCommentByme} className="only-me"><img src={by_me_1} />Câu hỏi của bạn</a>
                    </h3>
                    <BoxInputComment pushCmt={(new_comment)=>this.pushCmt(new_comment)} avatar={avatar} user_id={user_id} item_type={item_type} item_id={item_id} item_action={item_action} />
                    </> : 
                    <div style={{background:"#eaf0f5",padding:"10px",fontSize: "16px",color: "red", marginBottom:"12px"}}>Bạn cần đăng kí học chuyên đề/bài giảng này hoặc một khoá học bất kỳ để có thể đặt câu hỏi!</div> 
                }
                {
                    list_cmt_10_upvote.length > 0 ? <>
                    <h2>Bình luận nổi bật</h2><br/> 
                    { list_cmt_10_upvote.map((comment, index) =>
                        <div className="userBlock" key={comment._id} id={comment._id}>
                            <img src={comment.avatar} alt="" className="avatar" />
                            <div className="userInfo">
                                <div className="usernameAndDate">
                                    <span className="username bold">{comment.fullname}:</span>
                                    <span className="dateTime"> {moment.unix(comment.create_time).format('HH:mm DD/MM/YYYY')}</span>
                                </div>
                                <div className="content">
                                    <div dangerouslySetInnerHTML={{ __html: comment.html_content }} />
                                    {
                                        comment.images && comment.images.length > 0 ?
                                        <div className={"cardBg questionImg" + (comment.images.length > 1?" mutilImg": "") } >
                                        { comment.images.map(function (img, index_child_img){
                                            return (
                                                <a key={index_child_img} style={{cursor:"pointer"}} onClick={(e) => self.handleViewerImage(img)}><img src={img} alt="" /></a>
                                            )
                                        })} </div>: ''
                                    }
                                </div>
                                <BoxActionComment data_comment={comment} setActionId={(type, action_id)=>this.setActionId(type, action_id)} />
                                
                                <SubComment pingMathjax={this.pingMathjax}  rootAuthorId={comment.author_id} item_type={item_type} item_action={item_action} item_id={item_id} show_answer_id={show_answer_id} rootCommentId={comment._id} 
                                    user_id={user_id} avatar={avatar} totalSubComment={comment.total_sub_comment} />
                            </div>
                        </div>
                    )} <hr/></> : ''
                }
                <h2>Bình luận của học sinh</h2><br/>
                {listComment.map((comment, index) =>
                    <div className="userBlock" key={comment._id} id={comment._id}>
                        <img src={comment.avatar} alt="" className="avatar" />
                        <div className="userInfo">
                            <div className="usernameAndDate">
                                <span className="username bold">{comment.fullname}:</span>
                                <span className="dateTime"> {moment.unix(comment.create_time).format('HH:mm DD/MM/YYYY')}</span>
                            </div>
                            <div className="content">
                                <div dangerouslySetInnerHTML={{ __html: comment.html_content }} />
                                {
                                    comment.images && comment.images.length > 0 ?
                                    <div className={"cardBg questionImg" + (comment.images.length > 1?" mutilImg": "") } >
                                    { comment.images.map(function (img, index_child_img){
                                        return (
                                            <a key={index_child_img} style={{cursor:"pointer"}} onClick={(e) => self.handleViewerImage(img)}><img src={img} alt="" /></a>
                                        )
                                    })} </div>: ''
                                }
                            </div>

                            <BoxActionComment data_comment={comment} permission_cmt={permission_cmt} setActionId={(type, action_id)=>this.setActionId(type, action_id)} is_mod_hoidap={is_mod_hoidap} user_id={user_id}  />
                            <SubComment pingMathjax={this.pingMathjax} rootAuthorId={comment.author_id} item_type={item_type} item_id={item_id} item_action={item_action} show_answer_id={show_answer_id} rootCommentId={comment._id} 
                                user_id={user_id} avatar={avatar} totalSubComment={comment.total_sub_comment} is_mod_hoidap={is_mod_hoidap} />
                        </div>
                    </div>
                )}

                {totalComment > (LIMIT_COMMENT_ITEM * page) ? (
                    <div className="btnLoadmore">
                        <button onClick={()=>this.loadmoreComment(page+1)} > Xem thêm bình luận</button>
                    </div>
                ) : (<></>)}

            </div>
        );
    }
}

export default Comment;